import {
  Component,
  OnInit,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import Swal, { SweetAlertResult } from 'sweetalert2';
import { FormValidatorService } from 'src/app/shared/services/form-validator.service';
import { Validators } from 'src/app/shared/validators';
import { AuthService } from 'src/app/shared/services/auth.service';
import { UpdateActivationStatusService } from 'src/app/shared/services/update-activation-status.service';
import {
  ActivationStep,
  ActivationStepsService,
} from 'src/app/shared/services/activation-steps.service';
import { ACTIVATION_STEPS } from 'src/app/shared/activationSteps';
import { CCFetchBusinessDataService } from '../../../services/ccfetch-business-data.service';
import { VerifyFacebook } from 'src/app/shared/services/verify-facebook.service';
import { PhoneVerifyComponent } from 'src/app/shared/components/phone-verify/phone-verify.component';
import { SendVerifyEmailService } from 'src/app/shared/services/send-verify-email.service';
import { UpdateUserInfoService } from 'src/app/shared/components/change-password/update-user-info.service';
import { FetchBasicUserInfoService } from '../../../services/fetch-basic-user-info.service';
import { ContactFormResult } from '../new-activation-page.component';
import { VerifyMailService } from 'src/app/shared/services/verify-mail.service';
import { OtpDialogComponent } from './OtpDialogComponent';

@Component({
  selector: 'app-contact-information',
  templateUrl: './contact-information.component.html',
  styleUrls: ['./contact-information.component.scss'],
})
export class ContactInformationComponent implements OnInit {
  businessId: number;

  contactForm!: FormGroup;
  isVerifed: boolean = false;
  facebookPattern = /^(https?:\/\/)?(www\.)?facebook.com\/[\u0621-\u064A\u0660-\u0669a-zA-Z0-9(\.\?)?]/;
  twitterPattern = /^(https?:\/\/)?(www\.)?twitter.com\/[\u0621-\u064A\u0660-\u0669a-zA-Z0-9(\.\?)?]/;
  linkedInPattern = /^(https?:\/\/)?(www\.)?linkedin.com\/[\u0621-\u064A\u0660-\u0669a-zA-Z0-9(\.\?)?]/;
  instagramPattern = /^(https?:\/\/)?(www\.)?instagram.com\/[\u0621-\u064A\u0660-\u0669a-zA-Z0-9(\.\?)?]/;
  passwordHide: boolean = true;
  passwordConfirmHide: boolean = true;
  phoneVerifyClicked: boolean = false;
  initialEmail: string = '';
  num!: string;
  subscription!: Subscription;
  notOnlyNumPattern = /(?!^\d+$)^.+$/g;
  OnlyNumPattern = /^\d+$/;
  subscriptions: Subscription[] = [];
  mail_verified;
  phone_verified;
  facebook_verified;
  constructor(
    private translate: TranslateService,
    public formValidator: FormValidatorService,
    private auth: AuthService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    public UpdateActivationStatus: UpdateActivationStatusService,
    public ActivationSteps: ActivationStepsService,
    private verifyFb: VerifyFacebook,
    private fetchBusinessData: CCFetchBusinessDataService,
    private updateUser: UpdateUserInfoService,
    private sendverifyMail: SendVerifyEmailService,
    private verifyMail: VerifyMailService,
    private fetchInfo: FetchBasicUserInfoService
  ) {}
  ngAfterViewInit() {
    this.translateValidationMessages();
    this.translate.onLangChange.subscribe(() => {
      this.translateValidationMessages();
    });
  }

  translateValidationMessages() {
    this.translate.get('FormValidation').subscribe(() => {
      this.formValidator.validationMessages = {
        ...this.formValidator.validationMessages,
        email: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Email',
            fieldAr: 'البريد الإلكتروني',
          }),
          email: this.translate.instant('FormValidation.ValidEmail'),
        },
        instagram: {
          pattern: this.translate.instant('FormValidation.Pattern', {
            field: 'instagram',
            fieldAr: 'انستاجرام',
          }),

        },
        link_li: {
          pattern: this.translate.instant('FormValidation.Pattern', {
            field: 'linkedIn',
            fieldAr: 'لينكيدان',
          }),

        },
        phone: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Phone Number',
            fieldAr: 'رقم هاتف',
          }),
          requiredNumber: this.translate.instant(
            'FormValidation.RequiredNumber'
          ),
        },
      };
    });
  }
  async ngOnInit() {
    this.auth.getBusinessService.clear();
    const business = await this.auth.getBusinessService.getBussinessCopy();
    this.businessId = business.id;

    this.contactForm = this.formValidator.createForm([
      {
        fieldName: 'email',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
        ],
      },
      {
        fieldName: 'phone',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
        ],
      },

      {
        fieldName: 'website',
        defaultValue: null,
      },
      {
        fieldName: 'link_fb',
        defaultValue: '',
        validators: [
          {
            validatorFn: Validators.pattern(this.facebookPattern),
            message: 'not a valid facebook url',
          },
          {
            validatorFn: Validators.required,
            message: "Facebook Profile Link can't be empty",
          },
        ],
      },
      {
        fieldName: 'instagram',
        defaultValue: '',
        validators: [
          {
            validatorFn: Validators.pattern(this.instagramPattern),
            message: 'not a valid instagram url',
          },
        ],
      },
      {
        fieldName: 'link_li',
        defaultValue: '',
        validators: [
          {
            validatorFn: Validators.pattern(this.linkedInPattern),
            message: 'not a valid linkedIn url',
          },
        ],
      },
      {
        fieldName: 'cs_email',
        defaultValue: '',
        validators: [
          {
            validatorFn: Validators.email,
            message: 'not a valid email format',
          },
        ],
      },
      {
        fieldName: 'cs_phone',
        defaultValue: '',
        validators: [
          {
            validatorFn: Validators.pattern(this.OnlyNumPattern),
            message: 'must be only numbers',
          },
        ],
      },
    ]);
    const result = await this.fetchBusinessData.make();

    this.contactForm.controls['email'].setValue(result.Users[0].email);
    this.contactForm.controls['phone'].setValue(result.Users[0].phone);
    this.contactForm.controls['cs_email'].setValue(business.cs_email);
    this.contactForm.controls['cs_phone'].setValue(business.cs_phone);
    this.contactForm.controls['link_fb'].setValue(result.link_fb);
    this.mail_verified = result.Users[0].Verification.mail_verified;
    this.phone_verified = result.Users[0].Verification.phone_verified;
    this.facebook_verified = result.Users[0].Verification.facebook_verified;

    this.isVerifed = await this.isActiveStatus();

  }
  async initFormValues(oldContractValues:Partial<ContactFormResult>){

  let business = await this.auth.getBusiness()
  let oldValues={...oldContractValues,...business};
    Object.keys(this.contactForm.controls).forEach((control) => {
      if (oldValues[control]) {
        this.contactForm.controls[control].setValue(oldValues[control]);
      }
    });

 }
  ngOnDestroy() {
    this.subscriptions.forEach((subs) => subs.unsubscribe());
  }
  async verifyCode(code: string): Promise<string> {
    this.verifyFb.setParams({ code });
    const res: IVerifyResponse = await this.verifyFb.make();
    if (res.msg == 'Verified') {
      this.facebook_verified = true;
      let params: ActivationStep = {
        activationStep: ACTIVATION_STEPS.FACEBOOK_ACTIVATION,
        activationStatus: true,
      };
      this.UpdateActivationStatus.setParams(params);
      let result: Result = await this.UpdateActivationStatus.make();
      if (result.success) {
        this.ActivationSteps.setVerifyFacebookStep = params;
      }
    }
    return res.msg;
  }
  facebookVerificationPopup(): void {
    if (!this.ActivationSteps.getVerifyFacebookStep) {
      Swal.fire({
        title: this.translate.instant(
          'Sellers.Products.EnterVerifyFacebookCode'
        ),
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off',
        },
        cancelButtonText: this.translate.instant('Sellers.Products.Cancel'),
        showCancelButton: true,
        confirmButtonText: this.translate.instant('Sellers.Products.Verify'),
        showLoaderOnConfirm: true,
        preConfirm: async (code) => {
          const result: string = await this.verifyCode(code);
          if (result != 'Verified') {
            Swal.showValidationMessage(`${result}`);
          } else {
            this.facebook_verified = result;
            return;
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result:SweetAlertResult) => {
        if (result.value) {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: this.translate.instant('Sellers.Products.Verify'),
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
    }
  }
  async isActiveStatus() {
    let business = await this.auth.getBusiness();
    if (!business) return false;
    if (business.activeStatus != 'UnVerified') {
      return true;
    }
    return false;
  }

  async OnFormSubmit() {
    try {
      if (this.contactForm.invalid) {
        this.formValidator.forceShowErrors();
        return this.contactForm.value;
      }
      const { phone, email } = this.contactForm.value;
      await this.displayInfo();
      return this.contactForm.value;
    } catch (err) {
      let error = err.faultyRequest.error;
      this.formValidator.formErrors[error.error.field] = error.error.message;
      console.log(err);
    }
  }

  async VerifyPhone() {
    try {
      this.updateUser.setParams({
        email: this.contactForm.controls['email'].value,
        phone: this.contactForm.controls['phone'].value,
      });
      await this.updateUser.make();
      this.phoneVerifyClicked = true;
      const dialogRef = this.dialog.open(PhoneVerifyComponent, {
        height: '250px',
        width: '400px',
        data: {
          confResult: this.num,
        },
      });

      this.subscription = dialogRef.afterClosed().subscribe(() => {
        this.displayInfo();
      });
    } catch (err) {
      let error = err.faultyRequest.error;
      this.formValidator.formErrors[error.error.field] = error.error.message;
      console.log(err);
    }
  }

  //send only the email
  /**
   * this method sends email
   * i want to add an endpoint to call /verify/email/send
   * and pop up a field to enter otp after it sends the otp
   * then verify it 
   */
  async verify_email() {
    try {
      this.updateUser.setParams({
        email: this.contactForm.controls['email'].value,
        phone: this.contactForm.controls['phone'].value,
      });
      await this.updateUser.make();
      await this.sendverifyMail.make();
      this.snackBar.open(
        this.translate.instant('Sellers.Products.VerificationEmail'),
        '',
        { duration: 3000 }
      );
      const otp = await this.showOtpInputDialog();

      if (otp) {
        this.verifyMail.setParams({ otp: otp });
        await this.verifyMail.make(); 

        this.snackBar.open(
          this.translate.instant('Sellers.Products.OtpVerified'),
          '',
          { duration: 3000 }
        );
        await this.displayInfo();
      } else {
        throw new Error('OTP was not provided');
      }
    } catch (err) {
      let error = err.faultyRequest.error;
      if (error?.message === 'Invalid OTP') {
        this.snackBar.open(
          this.translate.instant('Sellers.Products.InvalidOtp') || 'Invalid OTP',
          '',
          { duration: 3000 }
        )}
      this.formValidator.formErrors[error.error.field] = error.error.message;
      console.log(err);
    }
  }
  private async displayInfo() {
    const result = await this.fetchInfo.make();
    this.num = result.phone;
    if (this.initialEmail && this.initialEmail != result.email) {
      this.auth.logout();
    }
    this.contactForm.controls['email'].setValue(result.email);
    this.contactForm.controls['phone'].setValue(result.phone);
    this.mail_verified = result.mail_verified;
    this.phone_verified = result.phone_verified;
    if (this.phone_verified && this.mail_verified) {
      let params = {
        activationStep: ACTIVATION_STEPS.PHONE_EMAIL_VERIFICATION,
        activationStatus: true,
      };
      this.UpdateActivationStatus.setParams(params);
      let result = await this.UpdateActivationStatus.make();
      if (result.success) {
        this.ActivationSteps.setPhoneAndEmailVerifyStep = params;
      }
    }
    this.initialEmail = result.email;
    if (result.mail_verified) this.contactForm.controls['email'].disable();

    if (result.phone_verified) this.contactForm.controls['phone'].disable();
  }
  private async showOtpInputDialog(): Promise<string | null> {
    const dialogRef = this.dialog.open(OtpDialogComponent, {
      width: '300px',
      data: {
        email: this.contactForm.controls['email'].value,
        sendverifyMail: this.sendverifyMail,
        snackBar: this.snackBar, 
      },
    });
  
    return dialogRef.afterClosed().toPromise();
  }

  async sendSMS() {
    this.VerifyPhone();
  }
  showComponentErors(){
      if(this.contactForm.valid){
      if (!this.phone_verified && !this.mail_verified) {
        this.snackBar.open(
          this.translate.instant('Sellers.Dashboard.VerifyEmail'),
          '',
          {
            duration: 5000,
          }
        );
      }

    }else{
      this.snackBar.open(
        this.translate.instant('Sellers.Products.Invalid_Contact_Info'),
        '',
        {
          duration: 5000,
        }
      )
    }
  }

  showFormErrors(errors) {
    if (errors.validationErrors?.error) {
      for (const e of errors.validationErrors.error) {
        this.formValidator.addError(e.field, 'invalid', e.message);
        this.contactForm.controls[e.field].setErrors({ invalid: e.message });
        this.formValidator.ShowErrors();
      }
    }
  }

  isComponentValid() {
    return this.contactForm.valid &&this.phone_verified  &&this.mail_verified;
  }

}
interface IVerifyResponse {
  msg: string;
}
interface Result {
  success: boolean;
}
